import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { IBudgetFixFlip } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetFixFlipField } from '../../../../../queries/useBudgetFixFlipField';

interface OutdoorStructuresProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const OutdoorStructures: React.FC<OutdoorStructuresProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [outdoorStructures, set_outdoorStructures] = useBudgetFixFlipField<number>(
        propertyGuid,
        (b) => (b.values?.['Final Structure']?.['Outdoor Structures']?.[1] as number) ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Final Structure': { ...b.values?.['Final Structure'], 'Outdoor Structures': [b.values?.['Final Structure']?.['Outdoor Structures']?.[0] ?? '', v] as [string, number] } } })
    );
    const label = 'Outdoor Structures (deck, patio, porches)';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(outdoorStructures)}
                />
            ) : (
                <MoneyBox
                    id={'outdoorStructures'}
                    allowNegative={false}
                    value={outdoorStructures}
                    onChange={(value) => set_outdoorStructures(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
